import type { SocialLoginURLs } from '@jwp/ott-hooks-react/src/useSocialLoginUrls';

import SocialButton, { type SocialButtonVariant } from '../SocialButton/SocialButton';

import styles from './SocialButtonsList.module.scss';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';
import { useAppConfig } from '@jwp/ott-hooks-react/src/useAppConfig';

const SocialButtonsList = ({ socialLoginURLs }: { socialLoginURLs: SocialLoginURLs | null }) => {
  if (!socialLoginURLs) {
    return null;
  }
  const { featureFlags } = useConfigStore.getState();
  const { isSocialLoginEnabled } = useAppConfig();
  if (isSocialLoginEnabled) {
    return (
      <div className={styles.socialButtonsListContainer}>
        {Object.entries(socialLoginURLs).map(([variant, url]) => {
          const isEnabled = featureFlags?.authentication?.social_login_providers?.[variant as keyof typeof featureFlags.authentication.social_login_providers];
          if (isEnabled) {
            return <SocialButton key={variant} variant={variant as SocialButtonVariant} href={url} />;
          }
          return null;
        })}
      </div>
    );
  }
};

export default SocialButtonsList;
